import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import NativeNextLink from "next/link";
import React from "react";
export var NextLink = function(props) {
    var innerRef = props.innerRef, to = props.to, otherProps = _object_without_properties(props, [
        "innerRef",
        "to"
    ]);
    return /*#__PURE__*/ _jsx(NativeNextLink, _object_spread({
        ref: innerRef,
        href: to
    }, otherProps));
};
